export default {
  getPolyline(json) {
    const polylineJson = JSON.parse(json)
    return polylineJson.polylines
  },
}
